import { Tooltip as AntTooltip, TooltipProps as AntTooltipProps } from 'antd';
import React from 'react';
import { theme } from '../../theme/semanticTokens';

export type TooltipPlacement =
  | 'topLeft'
  | 'topCenter'
  | 'topRight'
  | 'leftTop'
  | 'leftBottom'
  | 'rightTop'
  | 'rightBottom'
  | 'bottomLeft'
  | 'bottomCenter'
  | 'bottomRight';

export interface TooltipProps
  extends Omit<AntTooltipProps, 'placement' | 'title'> {
  title: React.ReactNode;
  placement?: TooltipPlacement;
  children: React.ReactNode;
  className?: string;
  minWidth?: string;
}

const PLACEMENT_MAP: Partial<
  Record<TooltipPlacement, AntTooltipProps['placement']>
> = {
  topCenter: 'top',
  bottomCenter: 'bottom'
};

const MAX_WIDTH = '320px';

export const Tooltip: React.FC<TooltipProps> = ({
  title,
  placement = 'topCenter',
  children,
  className = '',
  minWidth = 'inherit',
  ...props
}) => {
  const antPlacement =
    PLACEMENT_MAP[placement] ?? (placement as AntTooltipProps['placement']);

  return (
    <AntTooltip
      title={title}
      placement={antPlacement}
      className={className}
      arrow
      overlayStyle={{ maxWidth: MAX_WIDTH }}
      overlayInnerStyle={{
        backgroundColor: theme.dime.colors.fill.inverse,
        color: theme.dime.colors.text.inverse,
        borderRadius: theme.dime.radius.s,
        padding: theme.dime.spacing.m,
        maxWidth: MAX_WIDTH,
        minWidth,
        lineHeight: '22px',
        boxShadow: '0px 0px 14px 0px rgba(0, 0, 0, 0.08)'
      }}
      color={theme.dime.colors.fill.inverse}
      {...props}
    >
      {children}
    </AntTooltip>
  );
};
